module.exports = __webpack_public_path__ + "img/banner-principal.f17507d3.png";